module.exports = __webpack_public_path__ + "img/share.efad639c.svg";